/**
 * Datagate 3 API Doc
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ConfigRow } from './configRow';

export interface DeviceConfiguration {
  availableChannelTypes?: Array<number>;
  isMicroLog?: boolean;
  configRows?: Array<ConfigRow>;
  updatedAt?: Date;
  encodedConfigRows?: Array<any>;
  channelTypeModesOverwriteForMicroLog?: ChanelTypeModesOverwriteForMicroLog;
}

export interface ChanelTypeModesOverwriteForMicroLog {
  [Key: number]: ConfigChannelTypeFirmwareMapping;
}

export interface ConfigChannelTypeFirmwareMapping {
  id?: number;
  name?: string;
  availableModes?: Array<number>;
  statusAvailableModes?: Array<number>;
}

export enum ConfigExportFormat {
  UNL1 = 'UNL1',
  MBF = 'MBF'
}
